import { browserHistory } from 'react-router';
import moment from 'moment';
import RestBuilder from '../../rest/RestBuilder';
import HomeActionType from '../../common/HomeActionType';
import CheckoutActionType from '../../common/CheckoutActionType';
import SignupPaymentActionType from '../../common/SignupPaymentActionType';
import SuccessActionType from '../../common/SuccessActionType';
import SubmitSignupService from '../../services/SubmitSignupService';
import SubmitPromoCodeService from '../../services/SubmitPromoCodeService';
import { PlansSelector } from '../../redux/reducers/PlansReducer';
import PlansActionType from '../../common/PlansActionType';

const storePaymentDetails = formValues =>
  dispatch => dispatch({ type: SignupPaymentActionType.STORE_PAYMENT_DETAILS, formValues });

const storeClickGatewayDetails = clickDetails =>
  dispatch => dispatch({ type: SignupPaymentActionType.CLICK_GATEWAY_DETAILS, clickDetails });

const updateClickErrorMessage = clickErrorStatus =>
  dispatch => dispatch({ type: SignupPaymentActionType.CLICK_ERROR_MESSAGE_UPDATE, clickErrorStatus });

const validatePromoCode = promoCode =>
  async (dispatch) => {
    const response = await new SubmitPromoCodeService(new RestBuilder().mimeJson().build()).request(promoCode);
    if (response.code && !response.consumed) {
      dispatch({
        type: SignupPaymentActionType.VALIDATE_PROMO_CODE,
        promotionCode: promoCode,
        validatedPromoCode: true
      });
    }
    if (!response.code) {
      dispatch({
        type: SignupPaymentActionType.VALIDATE_PROMO_CODE,
        promotionCode: promoCode,
        validatedPromoCode: false
      });
    }
    return response;
  };

const submitSignup = () =>
  async (dispatch, getState) => {
    const redirectToErrorPage = (err) => {
      console.error(err); // eslint-disable-line
      dispatch({ type: HomeActionType.RESET_ALL });
      dispatch({ type: CheckoutActionType.RESET_ALL });
      dispatch({ type: SignupPaymentActionType.RESET_ALL });
      browserHistory.push('/error');
    };

    try {
      const signupResponse = await new SubmitSignupService(new RestBuilder().mimeJson().build()).request(
        getState(),
        PlansSelector.getSelectedPlan(getState()),
        PlansSelector.getIsContractSelected(getState()),
        PlansSelector.getMobileDiscountInfo(getState()),
        PlansSelector.getIsByoModemSelected(getState())
      );
      const checkout = getState().form.checkout.values;
      const connectDate = (checkout.connectionDate === 'asap') ? moment().valueOf() : checkout.preferredDate.valueOf();
      const trackingId = `${checkout.email}_${connectDate}`;
      if (!signupResponse.signUpInfo.signupSuccessful) {
        redirectToErrorPage(signupResponse.signUpInfo.signupErrorMessage);
        return;
      }

      if (signupResponse.customerPayment.success) {
        // copy data from home, checkout, and payment stores into success
        dispatch({
          type: SuccessActionType.STORE_SIGNUP_SUCCESS_PLAN,
          plan: PlansSelector.getSelectedPlan(getState())
        });
        dispatch({
          type: SuccessActionType.STORE_SIGNUP_CONTRACT,
          contract: PlansSelector.getIsContractSelected(getState())
        });
        dispatch({ type: SuccessActionType.STORE_PARTNER, partner: getState().home.partner });
        dispatch({ type: SuccessActionType.STORE_TRACKING_ID, trackingId });
        dispatch({
          type: SuccessActionType.STORE_VALIDATED_PROMO_CODE,
          validatedPromoCode: getState().payment.validatedPromoCode
        });
        // reset home, checkout, payment; success will be reset when Success component unmounts
        dispatch({ type: HomeActionType.RESET_ALL });
        dispatch({ type: CheckoutActionType.RESET_ALL });
        dispatch({ type: SignupPaymentActionType.RESET_ALL });
        browserHistory.push('/success');
        dispatch({ type: PlansActionType.RESET_ALL });
      } else if (window.submitFail) {
        window.submitFail({ genericError: 'Couldn&#39;t create payment account' });
      }
    } catch (err) {
      redirectToErrorPage(err);
    }
  };

const resetCheckoutForm = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.RESET_ALL });
};

const SignupPaymentAction = {
  submitSignup,
  storePaymentDetails,
  validatePromoCode,
  resetCheckoutForm,
  storeClickGatewayDetails,
  updateClickErrorMessage
};

export default SignupPaymentAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/SignupPaymentAction.js
 **/